import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVWinConfigs, BigWinLevel} from "../../configs/BenjiKIVWinConfigs";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";
import {gsap} from "gsap";

/**
 * Created by Jerker Nord on 2022-11-09.
 */

export class BenjiKIVBigWinRunner implements SimplePresentation {

    private _controller:SimplePresentationRunnerController;

    public shouldRun():boolean {
        return BenjiKIV.model.winRatio >= 15;
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;
        const levels:BigWinLevel[] = BenjiKIVWinConfigs.getBigWinLevels(BenjiKIV.model.winRatio);
        const nonAbortableTL:gsap.core.Timeline = gsap.timeline({onComplete : () => this.triggerMainTL()});
        nonAbortableTL.add(() => BenjiKIV.soundPlayer.fadeMusic(1, 0, 100));
        if (levels.length > 1){
            nonAbortableTL.add(() => BenjiKIV.soundPlayer.playNonLoopSound(BenjiKIVSound.BIG_WIN_MUSICS[0]));
        }else{
            nonAbortableTL.add(() => BenjiKIV.soundPlayer.playNonLoopSound(BenjiKIVSound.BIG_WIN_1_SOLO));
        }
        nonAbortableTL.add(BenjiKIV.bigWinView.show());
    }

    private triggerMainTL():void {
        const levels:BigWinLevel[] = BenjiKIVWinConfigs.getBigWinLevels(BenjiKIV.model.winRatio),
            tl:gsap.core.Timeline = gsap.timeline({onComplete : () => this._controller.finish()});
        let levelAborted = false;

        BenjiKIV.bigWinView.precalculateScale(BenjiKIV.model.winRatio * BenjiKIV.model.gameData.playedBetValue);

        tl.add(() => {
            BenjiKIV.multiplierCountUp.setYPos(false, true);
        }, 0);

        for(let level of levels) {
            tl.add(() => {levelAborted = false;});
            tl.add(() => this._controller.setSkipCallback(() => {
                levelAborted = true;
                tl.seek(level.name + "_end", false);
            }));

            tl.add(BenjiKIV.bigWinView.getLevelAnimation(level.from * BenjiKIV.model.gameData.playedBetValue, level.to * BenjiKIV.model.gameData.playedBetValue, level.duration, level.id));
            tl.addLabel(level.name + "_end");
            tl.add(() => this._controller.setSkipCallback());
            tl.add(() => {
                if(levelAborted) {
                    BenjiKIV.soundPlayer.stopSound(BenjiKIVSound.BIG_WIN_MUSICS[level.id - 1]);
                    BenjiKIV.soundPlayer.stopSound(BenjiKIVSound.BIG_WIN_1_SOLO);
                }
            });
        }

        tl.add([
            () => {BenjiKIV.soundPlayer.playSound(BenjiKIVSound.BIG_WIN_MUSIC_END)},
            () => BenjiKIV.soundPlayer.fadeMusic(0, 1, 1250)
        ]);

        tl.add(() => BenjiKIV.keypadPlugin.setWin(BenjiKIV.model.accumulatedRoundWin, BenjiKIV.model.showTotalWin, BenjiKIV.isWinBelowStake()));
        tl.add(BenjiKIV.bigWinView.showEnd());
        tl.add([
            () => BenjiKIV.initialWinView.hideAndResetAllSpineAnimations(),
            BenjiKIV.bigWinView.hide()
        ]);
    }
}